/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for password change endpoint.
 * @export
 * @interface APIChangePasswordRequest
 */
export interface APIChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof APIChangePasswordRequest
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof APIChangePasswordRequest
     */
    password2: string;
    /**
     * 
     * @type {string}
     * @memberof APIChangePasswordRequest
     */
    passwordOld: string;
}

/**
 * Check if a given object implements the APIChangePasswordRequest interface.
 */
export function instanceOfAPIChangePasswordRequest(value: object): value is APIChangePasswordRequest {
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('password2' in value) || value['password2'] === undefined) return false;
    if (!('passwordOld' in value) || value['passwordOld'] === undefined) return false;
    return true;
}

export function APIChangePasswordRequestFromJSON(json: any): APIChangePasswordRequest {
    return APIChangePasswordRequestFromJSONTyped(json, false);
}

export function APIChangePasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIChangePasswordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'],
        'password2': json['password_2'],
        'passwordOld': json['password_old'],
    };
}

export function APIChangePasswordRequestToJSON(value?: APIChangePasswordRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'password': value['password'],
        'password_2': value['password2'],
        'password_old': value['passwordOld'],
    };
}

